import React from 'react';
import {
    CheckboxItem,
    Item,
    Label,
    RadioItem,
    SubTrigger
} from '@radix-ui/react-dropdown-menu';
import {
    HBListItemSize,
    HBListItemTheme
} from '../HBListItem/HBListItem.types';
import { TMenuItemTheme, TMenuSize } from './HBMenu.types';

const SIZE_MAP: Record<TMenuSize, HBListItemSize> = {
    sm: 'sm',
    md: 'md',
    lg: 'md',
    fit: 'md'
} as const;

export const getHBListItemSize = (size: TMenuSize): HBListItemSize => {
    return SIZE_MAP[size] || 'md';
};

const THEME_MAP: Record<TMenuItemTheme, HBListItemTheme> = {
    default: 'neutral',
    destructive: 'danger',
    accent: 'accent'
} as const;

export const getHBListItemTheme = (theme: TMenuItemTheme): HBListItemTheme => {
    return THEME_MAP[theme] || 'neutral';
};

export const dropdownReferenceTypesMap: Record<
    'item' | 'singleSelect' | 'multiSelect' | 'subTrigger' | 'section',
    React.ComponentType<any>
> = {
    item: Item,
    // `singleSelect` is not auto-resolved by HBMenuItem — single items stay as
    // `'item'` (regular Item) by default. This entry is available for callers that
    // explicitly pass `dropdownReferenceType="singleSelect"` to opt into Radix's
    // RadioItem (which handles mutual exclusion natively within a RadioGroup).
    singleSelect: RadioItem,
    multiSelect: CheckboxItem,
    subTrigger: SubTrigger,
    section: Label
};
